import { UNAUTHORIZED, FORBIDDEN } from 'http-status-codes';

import { captureMessage } from '@quintoandar/fwp-error-monitoring';
import { clearProfileCache } from 'utils/cache';
import { logout, LOGOUT_ORIGIN } from 'utils/logout';
import { getLoginUrlWithRedirect } from 'utils/redirect';

const LOGOUT = 'LOGOUT';

export const unauthorizedRedirector = (store) => (next) => (action) => {
  if (action?.payload?.response?.status === UNAUTHORIZED) {
    captureMessage('unauthorizedRedirector', {
      extra: {
        action,
        state: store.getState(),
      },
    });

    store.dispatch({ type: LOGOUT });
    store.dispatch(
      logout(
        LOGOUT_ORIGIN.UNAUTHORIZED_REDIRECTOR,
        getLoginUrlWithRedirect(action.payload.redirectBack),
      ),
    );

    return undefined;
  }

  if (action?.payload?.response?.status === FORBIDDEN) {
    clearProfileCache(); // Clear profile cache and let /user/me and /accredited endpoints validate if user is still valid
    // This prevents redirecting to forbidden page due to API incorrectly returning 403
  }
  return next(action);
};

export default unauthorizedRedirector;
